import Dispatcherr from './architecture/Dispatch'
import objectParser from './helpers/objectParser'
import Rq from './modules/request'

export const Dispatcher = Dispatcherr
export const Request = Rq
export const Helpers = {
  objectParser
}